<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>运营中心</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="isHideDetails = false">渠道数据</a>
      </a-breadcrumb-item>
      <!-- <a-breadcrumb-item>总报表</a-breadcrumb-item> -->
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section v-show="!isHideDetails">
      <section class="searchBox" style="padding-left:2%;">
        <!-- <a-radio-group class="addStyle" @change="handleSizeChange">
          <a-radio-button value="总报表" class="ant-radio-button-wrapper-checked">总报表</a-radio-button>
          <a-radio-button value="入职员工统计">入职员工统计</a-radio-button>
          <a-radio-button value="拜访数据统计">拜访数据统计</a-radio-button>
        </a-radio-group>-->
        <span>
          <label>日期：</label>
          <a-range-picker
            v-model="date"
            :placeholder="['开始时间', '结束时间']"
            @change="onChangeDate"
          />
        </span>
        <span>
          <label>渠道：</label>
          <a-select
            v-model="resume_source_id"
            placeholder="请选择渠道"
            showSearch
            style="min-width:200px"
          >
            <a-select-option
              :value="item.id"
              v-for="(item, i) in channelList"
              :key="i"
              >{{ item.source_name }}</a-select-option
            >
          </a-select>
        </span>
        <!-- <span>
          <label>招聘人员姓名：</label>
          <div>
            <a-input placeholder="请输入姓名" v-model="nameSearch" />
          </div>
        </span>-->
        <span>
          <a-button style="margin-right:10px" @click="onReset">重置</a-button>
          <a-button type="primary" icon="search" @click="onSearch"
            >搜索</a-button
          >
          <!-- <a-button style="margin-left:20px;background:#001529;color:#fff" icon="cloud-download">下载</a-button> -->
        </span>
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <table>
          <thead>
            <tr>
              <th v-for="item in thList" :key="item">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data != ''" v-for="(item, i) in data" :key="i">
              <td>{{ item.source_name }}</td>
              <td>{{ item.total_num == 0 ? "--" : item.total_num }}</td>
              <td>
                {{
                  item.total_price == 0 ? "--" : Number(item.total_price) + "元"
                }}
              </td>
              <td>{{ item.total_resume == 0 ? "--" : item.total_resume }}</td>
              <td>
                {{ item.total_new_resume == 0 ? "--" : item.total_new_resume }}
              </td>
              <td>
                {{ item.total_entry == 0 ? "--" : item.total_entry + "人" }}
              </td>
              <td>
                <a @click="detailPage(item)">详情</a>
              </td>
            </tr>
            <tr v-show="data == ''">
              <td></td>
              <td></td>
              <td></td>
              <td>--- 暂无 ---</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>
    <!-- 详情 -->
    <channelDetail v-show="isHideDetails" :details="details" />
    <!-- 详情 end -->
  </div>
</template>
<script>
import axios from "axios";
import channelDetail from "@/components/management/channelDetail";
export default {
  data() {
    return {
      data: [],
      loading: false,
      page: 1,
      pagination: {},
      thList: [
        "渠道",
        "上贴数量",
        "成本",
        "简历总数",
        "新简历数",
        "总入职数",
        "操作"
      ],
      isHideDetails: false,
      details: {},
      nameSearch: "",
      searchDate: "",
      date: null,
      channelList: [],
      resume_source_id: ""
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  components: {
    channelDetail
  },
  mounted() {
    this.getData(); //获取列表
    this.getChannel(); //获取渠道
  },
  methods: {
    on_return() {
      if (window.event.keyCode == 13) {
        this.getData();
      }
    },
    onChangeDate(date, dateString) {
      this.searchDate = dateString;
      console.log(this.searchDate);
    },
    onChange(pageNumber) {
      this.page = pageNumber;
      this.getData();
    },
    onSearch() {
      this.page = 1;
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    getData() {
      // console.log(this.$store.state.token);
      this.loading = true;
      let url =
        this.httpsBasic.url + this.httpsBasic.resume + "Resume_source/count";
      let params = {
        current_page: this.page,
        per_page: 10,
        resume_source_id: this.resume_source_id,
        start_date: this.searchDate[0],
        end_date: this.searchDate[1],
        token: window.localStorage.getItem("xnwfPcToken")
      };
      if (this.searchDate == "") {
        delete params.start_date;
        delete params.end_date;
      }
      axios
        .post(url, params)
        .then(res => {
          // console.log(res);
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            // console.log(this.data);
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    detailPage(val) {
      // this.$router.push({name:"resumeDetails"})
      this.details = val;
      this.isHideDetails = true;
    },
    onReset() {
      this.date = undefined;
      this.searchDate = "";
      this.resume_source_id = "";
      this.page = 1;
      this.getData();
    },
    getChannel() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.resume +
        "Resume_source/resumeSourceList";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          per_page: 100000
        })
        .then(res => {
          if (res.data.code == 200) {
            this.channelList = res.data.data.data;
            // console.log(this.proList);
          }
        });
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
.listContainer {
  .ruzhiTJ {
    display: inline-block;
    li {
      display: inline-block;
      margin-right: 10px;
    }
  }

  .searchStyle {
    > input {
      margin: 0 20px;
      width: 200px;
    }
  }
  .searchBox {
    justify-content: flex-end;
    > span {
      display: inline-block;
      margin-bottom: 10px;
      margin-right: 20px;
      > div {
        display: inline-block;
      }
    }
  }
}
</style>
<style lang="less">
.listContainer {
  // .ant-radio-button-wrapper-checked {
  //   border: 1px solid #d9d9d9;
  // }
  // .ant-radio-button-wrapper-checked::before {
  //   opacity: 0;
  //   background-color: #d9d9d9!important;
  // }
  // .ant-radio-button-wrapper-checked{
  //   box-shadow: unset;
  // }

  .addStyle {
    label:frist-child {
      box-shadow: -1px 0 0 0 #1890ff;
    }
  }
}
</style>
